import React from 'react';
import HrbTranslate from '../../../components/language/HrbTranslate';

const EmptyPurchaseHistory = () => (
    <div className='columns'>
        <div className='column is-1' />
        <div className='column is-10'>
            <p className='p1'><HrbTranslate text='ReturnInfo.Placeholders.NoReturns' /></p>
        </div>
        <div className='column is-1' />
    </div>
)

export default EmptyPurchaseHistory;